/**
 * pz.headernotice
 * 
 * Controls display of header notice bar, and provides countdown timer to order shipping deadline.
 * Note: variables are passed via data tags on enclosing div in templates/layouts/main.html
 *     - data-deadline="{{ storeInfo.orderDeadline|date('Y-m-d H:i:s') }}"
 *     - data-text="{{ storeInfo.orderNotice }}" 
 *     - data-calendarjson="{{ calendarJson|e('html') }}
 * 
 * Requires: jquery, moment, pz
 */

$(function () {
    'use strict';

    if (window.pz === undefined) {
        window.pz = {};
    }

    pz.headernotice = function () {

        // override values (for testing)
        var override;

        /**
         * Optional for testing
         * now          String  local user time w/ UTC offset (i.e. '2018-01-03 12:30:00-08:00')
         * deadline     String  ship deadline, w/o UTC offset (i.e. '2018-01-03 14:00:00'),
         * timezone     String  timezone (i.e. 'America/Los_Angeles', 'America/New_York')
         */
        var initModule = function (now, deadline, timezone) {

            // add zone data to moment
            moment.tz.add(["America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6", "America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6"]);

            // override values (for tests)
            override = {
                now: now === undefined ? undefined : now,
                deadline: deadline === undefined ? undefined : deadline,
                timezone: timezone === undefined ? undefined : timezone
            };

            updateNotice();

            // update notice again every 10s
            var updateInterval = setInterval(function () {
                updateNotice();
            }, 10 * 1000);

            // display alternate notice
            var orderNotice = $('.js-header-notice li.orderNotice');
            var altOrderNotice = $('.js-header-notice li.altOrderNotice');
            if (altOrderNotice.length) {

                // hide alt notice
                altOrderNotice.hide();

                // alternate display every 10s
                var switchNoticeInterval = setInterval(function () {
                    orderNotice.fadeToggle(500);
                    altOrderNotice.fadeToggle(500);
                }, 10 * 1000);
            }

        };

        var updateNotice = function () {

            // data
            var $element = $('.js-header-notice');
            var notice = $element.data('text');
            var deadline = $element.data('deadline');
            var calendarJson = $element.data('calendarjson');
            var storeHoursJson = $element.data('storehoursjson');

            // system/default - use overide vars if defined (for testing)
            var now = override.now === undefined ? moment() : moment(override.now);
            var timezone = override.timezone === undefined ? 'America/Los_Angeles' : override.timezone;
            var tzDeadline = override.deadline === undefined ? moment.tz(deadline, timezone).year(now.year()).month(now.month()).date(now.date()) : moment.tz(override.deadline, timezone);

            // derived
            var isWeekday = tzDeadline.day() >= 1 && tzDeadline.day() <= 5;
            var isWorkday = false;
            var isHoliday = false;
            var isBeforeDeadline = tzDeadline.diff(now) > 0;
            var zoneAbbr = tzDeadline.zoneAbbr();
            var timer, hours, minutes, seconds;

            // is today a workday?
            if (storeHoursJson[now.day()].open != null) {
                isWorkday = true;
            }

            // is today a holiday?
            $.each(calendarJson, function (index, element) {
                if (now.year() == moment(element.date).year() && now.dayOfYear() == moment(element.date).dayOfYear()) {
                    isHoliday = true;
                }
            });

            // set timer
            if (isWorkday && isBeforeDeadline && !isHoliday) {
                // M-F before cutoff and not holiday - ship today
                timer = moment.duration(tzDeadline.diff(now));
            }

            // set notice
            if (timer > 0) {
                hours = timer.hours() == 0 ? '' : timer.hours() + (timer.hours() == 1 ? ' hour ' : ' hours ');
                minutes = timer.minutes() == 0 ? '' : timer.minutes() + (timer.minutes() == 1 ? ' minute ' : ' minutes ');
                seconds = timer < 60 * 1000 ? ' few seconds ' : '';
                notice = "Order in the next " + hours + minutes + seconds + "and your order will ship today.";
            } else {
                // auto-set PST/PDT
                notice = notice.replace(/PST|PDT/gi, zoneAbbr);
            }

            // render
            $element.find('li.orderNotice').html(notice);

            // debugging
            if (false) {
                console.log('-');
                console.log('notice: ' + notice);
                console.log('now: ' + now.format());
                console.log('nowUTC: ' + now.clone().utc().format());
                console.log('tzDeadline' + zoneAbbr + ': ' + tzDeadline.format());
                console.log('tzDeadlineUTC: ' + tzDeadline.clone().utc().format());
                console.log('calendarJson: ' + JSON.stringify(calendarJson));
                console.log('isHoliday: ' + isHoliday);
                console.log('zoneAbbr: ' + zoneAbbr);
                if (timer > 0) {
                    console.log('timer: ' + timer.hours() + ':' + timer.minutes() + ':' + timer.seconds());
                }
            }
        };

        return {
            initModule: initModule
        };
    }();

    if ($('.js-header-notice')) {
        pz.headernotice.initModule();

        // tests
        //pz.headernotice.initModule('2018-01-03 13:59:30-08:00', '2018-01-03 14:00:00', 'America/Los_Angeles');    // test Wed 1:59:30pm
        //pz.headernotice.initModule('2018-01-03 13:33:30-08:00', '2018-01-03 14:00:00', 'America/Los_Angeles');    // test Wed 1:33pm
        //pz.headernotice.initModule('2018-01-03 12:33:00-08:00', '2018-01-03 14:00:00', 'America/Los_Angeles'); // test Wed 12:33pm
        //pz.headernotice.initModule('2018-01-03 12:33:00-08:00', undefined, 'America/Los_Angeles');                // test Wed 12:33pm (using order deadline)
        //pz.headernotice.initModule('2018-01-03 14:33:00-08:00', '2018-01-03 14:00:00', 'America/Los_Angeles');    // test Wed 2:33pm
        //pz.headernotice.initModule('2018-01-06 12:33:00-08:00', '2018-01-06 14:00:00', 'America/Los_Angeles');    // test Sat 12:33pm
        //pz.headernotice.initModule('2018-01-06 12:33:00-08:00', '2018-01-06 14:00:00', 'America/New_York');       // test Sat 12:33pm, EST
        //pz.headernotice.initModule('2018-06-06 14:33:00-08:00', '2018-06-06 14:00:00', 'America/Los_Angeles');    // test Wed 14:33pm, PDT
        
        // test holidays
        //pz.headernotice.initModule('2018-12-24 13:33:30-08:00', '2018-12-24 14:00:00', 'America/Los_Angeles');    // test Mon Dec 24, 2018 13:33pm, PDT
        //pz.headernotice.initModule('2018-12-25 13:33:30-08:00', '2018-12-25 14:00:00', 'America/Los_Angeles');    // test Tue Dec 25, 2018 13:33pm, PDT
    }
});